import * as Sentry from '@sentry/nextjs';

import { isSentryEnabled } from '@src/services/sentry';

export type FormValidationErrorEvent = {
	formName: string;
	errorType: string;
	fields?: string[];
	fieldMessages?: Record<string, string>;
};

export function trackFormValidationError(event: FormValidationErrorEvent): void {
	if (globalThis.LogRocket) {
		globalThis.LogRocket.track('form_validation_error', {
			formName: event.formName,
			errorType: event.errorType,
			...(event.fields ? { fields: event.fields } : {}),
			...Object.fromEntries(Object.entries(event.fieldMessages ?? {}).map(([k, v]) => [`field_${k}`, v])),
		});
	}

	if (isSentryEnabled()) {
		Sentry.captureMessage(`form.validation: ${event.formName}: ${event.errorType}`, {
			level: 'log',
			extra: event as Record<string, unknown>,
		});
	}
}
